
const fathers = [
  { id: 'Padre', name: 'Padre'},
  { id: 'Madre', name: 'Madre' },
]

const options = [
  { id: 'SI', name: 'SI'},
  { id: 'NO', name: 'NO' },
]

const optionsCupo = [
  { id: 'SI', name: 'SI'},
  { id: 'NO', name: 'NO' },
]

export {
  fathers,
  options,
  optionsCupo
};
